import { TASK_CACHE_TAGS, type CacheTag, type CreateTagInput } from '@frontend/api-client/utils';
import { useDispatchApi } from './useDispatchApi';

export const useInvalidateTaskCaches = ({
  taskCacheTags = TASK_CACHE_TAGS,
}: {
  taskCacheTags?: CreateTagInput<CacheTag>[];
} = {}) => {
  const { invalidateCache } = useDispatchApi();

  return (taskId?: string) => {
    const additionalTags: CreateTagInput<CacheTag>[] = taskId
      ? [
          { id: taskId, prefix: 'taskId', type: 'Task' },
          { id: taskId, prefix: 'taskId', type: 'Comment' },
        ]
      : [];

    invalidateCache([...(taskCacheTags ?? []), ...additionalTags]);
  };
};
